export const REPORT_ADD_TASK = {
  TITLE: "REPORTE DE CREACION DE TAREAS",
  BTN_ACCEPT: "Aceptar",
  EMIT_EVENT: "desactiveModal"
};
